import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_via() {
  return 'sms';
}
function get_property() {
  return 'phone';
}
var SmsClass;
function Sms() {
  if (SmsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Sms', VOID, VOID, [ProofClientEndpoints()], [1]);
    SmsClass = $;
  }
  return SmsClass;
}
function get_via_0() {
  return 'email';
}
function get_property_0() {
  return 'email';
}
var EmailClass;
function Email() {
  if (EmailClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Email', VOID, VOID, [ProofClientEndpoints()], [1]);
    EmailClass = $;
  }
  return EmailClass;
}
function get_via_1() {
  return 'totp';
}
var TimeBasedOTPClass;
function TimeBasedOTP() {
  if (TimeBasedOTPClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'TimeBasedOTP', VOID, VOID, [ProofClientEndpoints()], [1]);
    TimeBasedOTPClass = $;
  }
  return TimeBasedOTPClass;
}
function get_via_2() {
  return 'password';
}
var PasswordClass;
function Password() {
  if (PasswordClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Password', VOID, VOID, [ProofClientEndpoints()], [1]);
    PasswordClass = $;
  }
  return PasswordClass;
}
function get_via_3() {
  return 'backupcode';
}
var BackupCodeClass;
function BackupCode() {
  if (BackupCodeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'BackupCode', VOID, VOID, [ProofClientEndpoints()], [1, 0]);
    BackupCodeClass = $;
  }
  return BackupCodeClass;
}
function get_via_4() {
  return 'WebAuthN';
}
var WebAuthNClass;
function WebAuthN() {
  if (WebAuthNClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebAuthN', VOID, VOID, [ProofClientEndpoints()], [1]);
    WebAuthNClass = $;
  }
  return WebAuthNClass;
}
function get_property_1() {
  return null;
}
var ProofClientEndpointsClass;
function ProofClientEndpoints() {
  if (ProofClientEndpointsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProofClientEndpoints');
    ProofClientEndpointsClass = $;
  }
  return ProofClientEndpointsClass;
}
//region block: exports
export {
  get_via_3 as get_via1dsogpg00hdlv,
  BackupCode as BackupCode2jc2vekqp19f0,
  get_property_0 as get_property364tzqq3z832r,
  get_via_0 as get_via38yy5q0f9oxer,
  Email as Email1w7ox5oeijz9q,
  get_via_2 as get_via1akmqcvk1uw2r,
  Password as Password2oz6lme4sxm35,
  get_property as get_property2y9s85dtwsuvs,
  get_via as get_via1yox8ba35wqel,
  Sms as Sms390uee2xgepqo,
  get_via_1 as get_via1qy3fim7enjl0,
  TimeBasedOTP as TimeBasedOTP8rvmui1ob933,
  get_via_4 as get_viaslgbb3rik8va,
  WebAuthN as WebAuthN1n668ofp4zkcr,
  get_property_1 as get_property3fywtt2wxtx70,
  ProofClientEndpoints as ProofClientEndpoints22835nuu8vpwr,
};
//endregion

//# sourceMappingURL=ProofClientEndpoints.mjs.map
